// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roq-chat-message-menu-delete-modal__state {
  display: none;
}

.roq-chat-message-menu-delete-modal__state:checked
  + .roq-chat-message-menu-delete-modal__overlay {
  visibility: visible;
}

.roq-chat-message-menu-delete-modal__overlay {
  align-items: center;
  background-color: var(--color-shadow-modal);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  visibility: hidden;
  z-index: var(--z-modals);
}

.roq-chat-message-menu-delete-modal {
  align-self: center;
  background-color: var(--color-background);
  border-radius: var(--border-radius-tiny);
  padding: var(--spacing-large);
}

@media (min-width: 768px) {
  .roq-chat-message-menu-delete-modal {
    max-height: 80vh;
    min-width: 350px;
  }
}

.roq-chat-message-menu-delete-modal__body {
  margin-bottom: calc(2 * var(--spacing-medium));
}

.roq-chat-message-menu-delete-modal__body__description {
  color: var(--color-text-regular);
  font-size: var(--font-xl);
  font-weight: var(--font-weight-heading);
}

.roq-chat-message-menu-delete-modal__footer {
  display: flex;
  gap: var(--spacing-medium);
  justify-content: flex-end;
}

.roq-chat-message-menu-delete-modal__footer-btn {
  border-radius: var(--border-radius-tiny);
  font-size: var(--font-baseline);
  padding: var(--spacing-medium) var(--spacing-big);
  transition:
    background-color var(--preference-transition-duration-normal),
    color var(--preference-transition-duration-normal);
}

.roq-chat-message-menu-delete-modal__footer-cancel-btn {
  background-color: var(--color-background);
  border: 1px solid var(--color-text-light);
  color: var(--color-text-regular);
}

.roq-chat-message-menu-delete-modal__footer-cancel-btn:not(:disabled):hover {
  background-color: var(--color-primary-light);
  border-color: var(--color-primary-light);
  color: var(--color-text-alt);
}

.roq-chat-message-menu-delete-modal__footer-confirm-btn {
  background-color: var(--color-button-danger);
  border: 1px solid var(--color-button-danger);
  color: var(--color-text-alt);
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_window-delete-modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,iDAAiD;EACjD;;sDAEoD;AACtD;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,4BAA4B;AAC9B","sourcesContent":[".roq-chat-message-menu-delete-modal__state {\n  display: none;\n}\n\n.roq-chat-message-menu-delete-modal__state:checked\n  + .roq-chat-message-menu-delete-modal__overlay {\n  visibility: visible;\n}\n\n.roq-chat-message-menu-delete-modal__overlay {\n  align-items: center;\n  background-color: var(--color-shadow-modal);\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  position: fixed;\n  visibility: hidden;\n  z-index: var(--z-modals);\n}\n\n.roq-chat-message-menu-delete-modal {\n  align-self: center;\n  background-color: var(--color-background);\n  border-radius: var(--border-radius-tiny);\n  padding: var(--spacing-large);\n}\n\n@media (min-width: 768px) {\n  .roq-chat-message-menu-delete-modal {\n    max-height: 80vh;\n    min-width: 350px;\n  }\n}\n\n.roq-chat-message-menu-delete-modal__body {\n  margin-bottom: calc(2 * var(--spacing-medium));\n}\n\n.roq-chat-message-menu-delete-modal__body__description {\n  color: var(--color-text-regular);\n  font-size: var(--font-xl);\n  font-weight: var(--font-weight-heading);\n}\n\n.roq-chat-message-menu-delete-modal__footer {\n  display: flex;\n  gap: var(--spacing-medium);\n  justify-content: flex-end;\n}\n\n.roq-chat-message-menu-delete-modal__footer-btn {\n  border-radius: var(--border-radius-tiny);\n  font-size: var(--font-baseline);\n  padding: var(--spacing-medium) var(--spacing-big);\n  transition:\n    background-color var(--preference-transition-duration-normal),\n    color var(--preference-transition-duration-normal);\n}\n\n.roq-chat-message-menu-delete-modal__footer-cancel-btn {\n  background-color: var(--color-background);\n  border: 1px solid var(--color-text-light);\n  color: var(--color-text-regular);\n}\n\n.roq-chat-message-menu-delete-modal__footer-cancel-btn:not(:disabled):hover {\n  background-color: var(--color-primary-light);\n  border-color: var(--color-primary-light);\n  color: var(--color-text-alt);\n}\n\n.roq-chat-message-menu-delete-modal__footer-confirm-btn {\n  background-color: var(--color-button-danger);\n  border: 1px solid var(--color-button-danger);\n  color: var(--color-text-alt);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
